export default {
    organizationOrders: {},
    eventOrders: {},
    orderWebhookToken: null,
    memberPendingOrders: [],
}